<template>
  <b-modal
    id="checkout-modal"
    centered
    ref="checkout-modal"
    :title="modalTitle"
    size="xl"
    hide-footer
  >
    <section class>
      <div v-if="!isCheckoutSection">
        <div class="my-3" v-for="cartItem in cartitems" :key="cartItem.id">
          <div class="row">
            <div class="col-2">
              <img class="img-fluid" :src="cartItem.product.image ? cartItem.product.image.url : defaultImage" />
            </div>
            <div class="col-10">
              <div class="d-flex">
                <p
                  class="flex-fill"
                >{{ cartItem.name }} {{ cartItem.quantity > 0 ? ` x ${cartItem.quantity}` : ''}}</p>
                <p class="flex-fill">{{ cartItem.product.price }} تومان</p>
                <button class="btn btn-danger" @click="removeFromCart(cartItem.id)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>

          <hr />
        </div>
        <div v-if="cartitems.length === 0">
          <p>{{ cartEmptyLabel }}</p>
        </div>
      </div>
      <div v-if="isCheckoutSection">
        <p>درخواست شما دریافت شده است!</p>
      </div>

      <button
        v-show="cartitems.length > 0 && !isCheckoutSection"
        class="btn btn-success"
        @click="onNextBtn"
      >{{ buyLabel }}</button>
      <button
        v-if="isCheckoutSection"
        class="btn btn-success"
        @click="closeModal(true)"
      >{{ closeLabel }}</button>
    </section>
  </b-modal>
</template>

<script>
export default {
  name: "checkout-component",

  data() {
    return {
      modalTitle: "بررسی",
      removeLabel: "حذف",
      cartEmptyLabel: "موردی یافت نشد.",
      closeLabel: "بستن",
      isCheckoutSection: false,
    };
  },

  computed: {
    cartitems() {
      return this.$store.getters.cartItems;
    },

    openModal() {
      if (this.$store.getters.isCheckoutModalOpen) {
        return true;
      } else {
        return false;
      }
    },

    buyLabel() {
      let totalProducts = this.cartitems.reduce(
          (acc, product) => acc + product.quantity,
          0
        ),
        cartItems = this.$store.getters.cartItems,
        pricesArray = [],
        productLabel = "",
        finalPrice = "",
        quantity = 1;

      cartItems.forEach((cartItem) => {
        if (cartItem.quantity >= 1) {
          quantity = cartItem.quantity;
        }

        pricesArray.push(cartItem.product.price * quantity); // get the price of every product added and multiply quantity
      });

      finalPrice = pricesArray.reduce((a, b) => a + b, 0); // sum the prices

      if (totalProducts > 1) {
        // set plural or singular
        productLabel = "محصول";
      } else {
        productLabel = "محصول";
      }
      return `خرید ${totalProducts} ${productLabel}  ${finalPrice} تومان`;
    },

    isUserLoggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
  },

  methods: {
    closeModal(reloadPage) {
      this.$store.commit("showCheckoutModal", false);

      if (reloadPage) {
        window.location.reload();
      }
    },

    removeFromCart(id) {
      this.$store.dispatch("removeFromCart", id);
    },

    onNextBtn() {
      if (this.isUserLoggedIn) {
        this.sendOrder();
      } else {
        this.$store.commit("showCheckoutModal", false);
        this.$store.commit("showLoginModal", true);
      }
    },
    onPrevBtn() {
      this.isCheckoutSection = false;
    },

    sendOrder() {
      this.$store
        .dispatch("checkout")
        .then(() => {
          this.isCheckoutSection = true;
        })
        .catch((e) => {
          this.isCheckoutSection = false;
        });
    },
  },
};
</script>

